<template>
    <div class="all">
        <van-nav-bar
                :title="title"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right
        />
        <div class="showContent">
            <van-row style="background:linear-gradient(to bottom right, coral, #ffc987);margin: 0.5rem;
    border-radius: 0.5rem;
    padding: 1rem 1rem 1rem 1rem;
    color: #fff;">
               
                <van-col span="24">
                    hello,你在优推联盟已经{{myday}}天了，
                </van-col>
                <van-col span="24">
                    总收益{{myearn}}元！
                </van-col>
                <van-col span="24">
                    你收获了{{myearnTip}}
                </van-col>
            </van-row>

            <van-row v-if="parenet">
               
                <van-col span="8">
                   我的上级：
                </van-col>
                <van-col span="8">
                   {{parenet.storeName}}
                </van-col>
                <van-col span="8">
                    {{parenet.contactPhone}}
                </van-col>
            </van-row>
            <van-row v-if="childCount>0">
                <van-col span="6">我的团队</van-col>
                <van-col span="8">
                    下级{{childCount}}人
                    <span v-if="dowmCount>0"><br/>次下级{{dowmCount}}人</span>
                    
                    </van-col>
                <van-col span="10">
                   <van-field
        readonly
        clickable
        
        :value="projectNameValue"
        placeholder="选择月份"
        @click="showPicker = true"
    />
    
   
       <router-link class="van-cell" :to="{path:'jobItemPrice?traderId='+myid}">
                           下级统一设价
                        </router-link>
    
    <van-popup v-model="showPicker" round position="bottom">
        <van-picker
        title="选择月份"
        show-toolbar
        :columns="projectListArr"
        @cancel="showPicker = false"
        @confirm="changeConfirm"
        />
        
    </van-popup>




                </van-col>
            </van-row>

            <van-notice-bar
  left-icon="volume-o"
  text="点击【下级统一设价】 一键设置所有下级价格  点击【下级商户名】 单独设价。"
/>
<form action="/">
           <van-search
  v-model="key"
  show-action
  placeholder="请输入下级优推ID"
  @search="onSearch"
   @cancel="onCancel"
>
  
</van-search>
</form>

            <div class="rowOrder" v-if="sortArr&&sortArr.length>0">
                            <van-row class="head">
                                <van-col span="6">优推ID</van-col>
                                <van-col span="6">商户名</van-col>
                                 <van-col span="6">手机号</van-col>
                                 <van-col span="6">活跃度</van-col>

                            </van-row>
                            <van-row v-for="g in sortArr" :key="g.id">
                                <van-col span="6">
                                    <router-link :to="{path:'/user/jobItemPrice?traderId='+g.id}">
                                    {{g.id}}({{g.lowerCount}})
                                    </router-link>
                                </van-col>
                                <van-col span="6">
                                    <router-link :to="{path:'/user/jobItemPrice?traderId='+g.id}">
                                        {{g.traderName}}
                                    </router-link>
                                </van-col>
                                <van-col span="6">{{g.contactPhone}}</van-col>
                                <van-col span="6" style="text-align: right;">{{g.orderCount}}</van-col>
                             
                            </van-row>
                        </div>
                        <div class="noData" v-else>
                                <div><i class="icon-task icon-ku"></i></div>
                                <div>暂无数据</div>
                        </div>
                        <van-pagination @change="change" v-model="currentPage" :total-items=childCount :items-per-page=pageSize force-ellipses >
                            <template #prev-text>
                               <van-icon name="arrow-left" />
                            </template>
                            <template #next-text>
                               <van-icon name="arrow" />
                            </template>
                        </van-pagination>
           
        </div>

       

    </div>


</template>

<script>
   
    import userAPI from '@/api/user'

    export default {
        data() {
            return {
                group:{},
                parenet:{},
                myday:0,
                myearn:0,
                myearnTip:"",
                value: '',
                projectNameValue:'', //input框内显示的值
                projectListArr: [],//下拉的数据源，从接口中请求到数据，根据需要变成一维数组，只存name
                showPicker:false,  //弹出层显示隐藏
                nextCount:0,
                sortArr:[],
                currentPage: 1,
                pageSize:10,
                dowmCount:0,
                childCount:0,
                key:"",
                myid:-1,
                jobId:-1,


                
            }
        },
        computed: {
          
        },
        created() {
            if(this.$route.meta){
               this.title =   this.$route.meta.title
            }

           
           
           var nowDate = new Date();
         
           var preDate=new Date(new Date().setMonth(new Date().getMonth()-1));

           var pre2Date=new Date(new Date().setMonth(new Date().getMonth()-2));

           var m1=nowDate.getMonth()+1;
           if(m1<10){m1="0"+m1};
           var nowDateStr=nowDate.getFullYear()+""+m1;

           var m2=preDate.getMonth()+1;
           if(m2<10){m2="0"+m2};
           var preDateStr=preDate.getFullYear()+""+m2;

           var m3=pre2Date.getMonth()+1;
           if(m3<10){m3="0"+m3};
           var pre2DateStr=pre2Date.getFullYear()+""+m3;
         
           this.projectListArr.push(nowDateStr);
           this.projectListArr.push(preDateStr);
           this.projectListArr.push(pre2DateStr);
           //this.projectListArr.push("201906");
           //this.projectListArr.push("201904");

           //jobid
           if(this.$route.query.jobId){
                this.jobId=this.$route.query.jobId;
            }

            this.mygroup();

        },
    
        methods: {
            //加载团队信息
            mygroup() {
                this.submitLoading = true
            
                var form={};
                form.m=this.projectNameValue;
                userAPI.group(form).then((result) => {
                   
                    this.group=result.data;
                    
                    console.log(this.group.days)
                    this.myday=this.group.days;
                    this.myearn=this.group.totalInRMB;
                    this.myid=this.group.my.id;
                    if(parseFloat(this.myearn)>10000){
                      this.myearnTip="团队的力量";
                    }else if(parseFloat(this.myearn)>5000){
                      this.myearnTip="参自己的认可";
                    }else if(parseFloat(this.myearn)>1000){
                      this.myearnTip="一份稳定的工作";
                    }else if(parseFloat(this.myearn)>100){
                      this.myearnTip="一份不错的兼职";
                    }else{
                      this.myearnTip="一顿午餐";
                    }
                    
                     if(this.group.parenet!=null){  
                         this.parenet=this.group.parenet;
                     }

                     if(this.jobId!=-1){

                        // this.$router.push('/user/jobItemPrice?traderId='+this.myid+'&jobId=' + this.jobId)
                        // return;
                     }


                    this.change(1);
                    this.submitLoading = false
                   
                }).catch(()=>{
                  this.submitLoading = false
                })
            },
      
changeConfirm(val,index){
    this.projectNameValue = val;  //传值
    this.projectNameValue=this.projectListArr[index]
   
    this.showPicker=false;
    this.mygroup();
},
 onSearch(val) {
     
      console.log(val);
      this.key=val;
      this.change(1);
    },
     onCancel() {
       this.key='';
      this.change(1);
    },
test(){

    var form={};
                
                userAPI.jobItemPriceList(form).then((result) => {
                    console.log(result);
                });
  
},
 change(current) {
          //current 改变后的页码，pageSize 每页显示条数
        this.currentPage=current;

        var form={};
        form.m=this.projectNameValue;
        form.currentPage=this.currentPage;
        form.pageSize=this.pageSize;
        form.key=this.key;
        //console.log("log:",this.currentPage, this.pageSize);
        userAPI.groupDown(form).then((result) => {
          
            this.sortArr=result.data.pageItems;
            this.dowmCount=result.data.dowmCount;
            this.childCount=result.data.childCount;
          
        });
        
          
      },

    
          
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #fff;
    }
 .head{
                color:#000;
    box-shadow: 0 0 10px #e5e5e5;
               
              }

.noData{
      width: 11rem;
      height: 11rem;
      margin: 4rem auto 4rem auto;
      text-align: center;
      color: #E6E6E6;
      i{
        font-size: 5rem;
      }
    }

    .showContent {
        margin-top: 1rem;
        font-size: 1.1rem;
        .van-row {
            margin: 0.5rem 1rem 0rem 1rem;
            line-height: 3.5rem;
            img {
                height: 1.5rem;
                width: 2rem;
            }
            border-style: none;
            border-bottom-style: solid;
            border-bottom-width: thin;
            border-bottom-color: #f2f2f2;
            .van-button {
                border-radius: 1rem;
                background-color: #ee9900;
                color: #fff;
            }
        }

    }

    .bottom {
        margin: 3rem 15% 0rem 15%;
        .van-button {
            border-radius:3rem;
            background-color: #ee9900;
            color: #fff;
        }
    }

</style>
